import React from "react";
import bots from "../botsData";

const CookiePolicy = () => {
  const botNames = bots.map((bot) => bot.name).join(", ");

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto p-10 text-white bg-gray-900 rounded-lg shadow-lg mt-14 mb-20">
          <h1 className="text-4xl font-extrabold mb-6">Cookie Policy for Afterparty Bots</h1>
          <p className="text-gray-300 mb-6">Last Updated: January 20, 2026</p>

          <p className="text-lg mb-4">
            At <strong>Afterparty Bots</strong> (“we,” “our,” “us”), we value your privacy and are
            committed to being transparent about how we use cookies and similar technologies to collect
            information when you interact with our Bots ({botNames}).
          </p>
          <p className="text-gray-300 mb-6">
            This Cookie Policy explains what cookies are, how we use them, and the choices you have
            regarding their use.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">1. What Are Cookies?</h2>
          <p className="text-gray-300 mb-4">
            Cookies are small text files placed on your device when you visit a website or use an online
            service. These files help the service recognize your device and improve your experience by
            remembering preferences, login details, and other settings.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">2. Types of Cookies We Use</h2>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4">
            <li>
              <strong>Essential Cookies:</strong> Required for our bots to function (e.g., moderation
              features, role management, playback).
            </li>
            <li>
              <strong>Analytics Cookies:</strong> May be set by third parties (e.g., Discord analytics,
              bot management tools) to understand usage and improve performance.
            </li>
            <li>
              <strong>Performance Cookies:</strong> Help us monitor uptime, diagnose issues, and optimize
              performance.
            </li>
          </ul>

          <h2 className="text-2xl font-bold mt-6 mb-2">3. How We Use Cookies</h2>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4">
            <li><strong>Improve Functionality:</strong> Remember preferences and settings.</li>
            <li><strong>Monitor Performance:</strong> Understand interactions to improve experience.</li>
            <li><strong>Analyze Usage:</strong> Track aggregate trends to guide future updates.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-6 mb-2">4. Your Cookie Choices</h2>
          <p className="text-gray-300 mb-4">
            You can control cookies via your browser’s privacy settings. Disabling cookies may affect
            certain features. For Discord-based interactions, cookie and privacy preferences can also be
            managed in Discord’s own settings.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">5. Third-Party Cookies</h2>
          <p className="text-gray-300 mb-4">
            Our bots may interact with third-party services (e.g., Discord, analytics providers) who may
            set their own cookies under their privacy policies. We don’t control third-party cookies.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">6. Changes to this Cookie Policy</h2>
          <p className="text-gray-300 mb-4">
            We may update this policy to reflect changes in technology, legal requirements, or our
            services. Significant changes will be announced on our website or Discord server.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">7. Contact Us</h2>
          <p className="text-gray-300">
            Questions? Email us at{" "}
            <a href="mailto:support@afterpartylabs.xyz" className="text-blue-400 underline">
              support@afterpartylabs.xyz
            </a>.
          </p>
        </div>
      </main>
    </div>
  );
};

export default CookiePolicy;